<div class="title">
  <h3>Create a New Avatar</h3>
  <mat-icon [mat-dialog-close]>clear</mat-icon>
</div>
<div class="content">
  <iframe #rpmFrame src="https://wondapro.readyplayer.me/avatar?frameApi&clearCache" allow="clipboard-write"></iframe>
</div>